import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { Link, useParams } from 'react-router-dom';
import TopNavigation from '../Components/navigation/TopNavigation';
import { Parser } from 'html-to-react';
import MainFooter from '../Components/footer/MainFooter';
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import LoadingPage from '../Components/utils/LoadingPage';
import Helper from '../Components/utils/Helper';

function BlogSingle() {
    const params                                                       = useParams();

    const htmlParser                                                   = new Parser();
    const [currentBlog, setCurrentBlog]                                = useState(null);
    const [processing, setProcessing]                                  = useState(false);

    useEffect(() => {     
        collectCurrentEvent();
    }, []);

    const collectCurrentEvent = async () => {
      try{
       
        setProcessing(true);
        const response = await axios.get(CONSTANTS.URL_BLOG +"wp-json/ts/lovedripblg/blogs/v1/post/" +  params.id);
        setCurrentBlog(response.data);    
       setProcessing(false);
      }catch (err) {
          console.log(err);
          setProcessing(false);        
      }   
    }
    
    if (processing) {
        return <LoadingPage />;
    }
    return (
        <div className="main-layer">
            {
                currentBlog && (
                    <>
                        <Helmet>
                            <title>{currentBlog.title} </title>
                            <meta name="description" content={currentBlog.excerpt} />
                        </Helmet>
                        <div className="hero-banner-box"
                            style={{backgroundImage: `url("${currentBlog.featured_image.large}")`}}>
                            <TopNavigation title={"Blogs"} classBack="full-white" />
                            <div className="slim-section posi-bottom-left txt-white">
                                   <h3>{currentBlog.title}</h3>
                                   <div className="date-view">
                                        {Helper.formatDate(currentBlog.date)}
                                   </div>
                                   <div className="post-auther-view">
                                        {currentBlog.author}
                                   </div>
                            </div>

                        </div>
                        <div className="section-item">
                            <div className="container">
                                <h4>BLOG</h4>
                                {htmlParser.parse(currentBlog.content)}
                            </div>
                            
                            <div className="container text-center mt-5 mb-5">
                                <Link 
                                    className="btn btn-main btn-inlarge "
                                    to={"/blogs"}>
                                        View the rest of the blogs
                                </Link>
                            </div>
                        </div>
                         <MainFooter />
                    </>
                )
            }
           
           
        </div>
    )
}

export default BlogSingle